import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

/** Numărul mare, subțire, din capul fiecărei metrici secundare. */
export function DisplayValue({ children }: { children: ReactNode }) {
  return (
    <Typography
      component="span"
      sx={{
        fontWeight: 300,
        fontSize: 40,
        lineHeight: 1,
        letterSpacing: '-.03em',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Typography>
  );
}
